import type { ReactNode } from 'react';

/** `pa-panel` header: title, subtitle and an optional right-hand slot. */
export function PanelHead({
  title,
  subtitle,
  children,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  children?: ReactNode;
}) {
  return (
    <header className="pa-panel-head hp-card__header">
      <div>
        <h2>{title}</h2>
        {subtitle && <p className="pa-panel-subtitle">{subtitle}</p>}
      </div>
      {children}
    </header>
  );
}

const MARKS: Record<string, [string, string]> = {
  meta: ['M', 'meta'],
  google: ['G', 'google'],
  sklik: ['S', 'sklik'],
  email: ['P', 'pipedrive'],
};

/** Platform initial in a coloured square (`pa-service-mark`), Pipedrive's P for everything unpaid. */
export function ServiceMark({ channel }: { channel: string }) {
  const [letter, tone] = MARKS[channel] ?? ['P', 'pipedrive'];
  return (
    <span className={`pa-service-mark ${tone}`} aria-hidden="true">
      {letter}
    </span>
  );
}
